import {graphSpec} from './types';
import {PolarisStartChatOptionsVm} from '../../services/polaris/model';

export interface ChatMessage {
    id: string;
    author: ChatMessageAuthor;
    content: string;
    graphs?: graphSpec[];
    timestamp: number;
    followUpQuestions?: string[];
    error?: string;
    insights?: string;
    creativesURLs?: string[];
    interactionId?: string;
    userResponse?: UserMessageResponse;
    origin?: PolarisOrigin;
    widgetName?: string;
}

export enum ChatMessageAuthor {
    USER = 'user',
    ASSISTANT = 'assistant'
}

export enum UserMessageResponse {
    POSITIVE = 'positive',
    NEGATIVE = 'negative'
}

export const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;

export const POLARIS_NAME = 'POLARIS™';

export type PolarisOrigin = 'polaris_homepage' | 'alert_view_page' | 'polaris_wizard' | 'widget' | 'signals_screen';

export interface WizardSubmitEvent {
  message: string;
  options: PolarisStartChatOptionsVm;
  brand: string | null;
  competitors: string[];
}
